// Module
var code = "<div class=bible> <h2 class=passageref>2 Samuel 3.1</h2> <div class=bibletext> <p> </p><h2 class=plus-S>Abner Defects to David</h2><p><span class=cc>3</span>There was a long war between the house of Saul and the house of David; David grew stronger and stronger, while the house of Saul became weaker and weaker. </p> </div></div>";
// Exports
module.exports = code;